
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State } from 'react-powerplug'
import FormFieldSearch from './form-field-search'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldsearch"
    }}>{`FormFieldSearch`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "search-field"
    }}>{`Search field`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Consider using "Search" text instead of an icon.`}</p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      id=\"search\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} id='search' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "search-field-adjacent"
    }}>{`Search field (adjacent)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Consider using "Search" text instead of an icon.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={3} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      adjacent\n      id=\"search-adjacent\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} adjacent id='search-adjacent' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "search-field-inverse"
    }}>{`Search field (inverse)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Consider using "Search" text instead of an icon.`}</p>
    <Playground __position={5} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      id=\"search-inverse\"\n      inverse\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} id='search-inverse' inverse labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "search-field-inverse-adjacent"
    }}>{`Search field (inverse, adjacent)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Consider using "Search" text instead of an icon.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={7} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      id=\"search-inverse\"\n      adjacent\n      inverse\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} id='search-inverse' adjacent inverse labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "search-field-slim"
    }}>{`Search field (slim)`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Use where inputs are nested or constrained by layout.
Consider using "Search" text instead of an icon.`}</p>
    <Playground __position={9} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      id=\"search-slim\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} id='search-slim' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' slim mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "search-field-slim-adjacent"
    }}>{`Search field (slim, adjacent)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Use where inputs are nested or constrained by layout.
Consider using "Search" text instead of an icon.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={11} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      id=\"search-slim\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n      slim\n      adjacent\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} id='search-slim' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' slim adjacent mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "search-field-slim-inverse"
    }}>{`Search field (slim, inverse)`}</h2>
    <h3 {...{
      "id": "description-6"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Use where inputs are nested or constrained by layout.
Consider using "Search" text instead of an icon.`}</p>
    <Playground __position={13} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      id=\"search-slim-inverse\"\n      inverse\n      slim\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} id='search-slim-inverse' inverse slim labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "search-field-slim-inverse-adjacent"
    }}>{`Search field (slim, inverse, adjacent)`}</h2>
    <h3 {...{
      "id": "description-7"
    }}>{`Description`}</h3>
    <p>{`For single input search forms. Use where inputs are nested or constrained by layout.
Consider using "Search" text instead of an icon.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={15} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldSearch\n      {...state}\n      id=\"search-slim-inverse\"\n      inverse\n      slim\n      adjacent\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Search text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldSearch
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldSearch {...state} id='search-slim-inverse' inverse slim adjacent labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Search text placeholder' mdxType="FormFieldSearch" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldSearch} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;